// extracted by mini-css-extract-plugin
export default {"homeproduct__wrapper":"home_homeproduct__wrapper__jso8R","handwear__wrapper":"home_handwear__wrapper__NGNht"};